import React from "react";
import { useUploadDocument } from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/modal";
import { Loader } from "@common/loader";
import { Props } from "./types";
import { DropZone } from "./dropZone";
import { Icon } from "./icon";
import { FileInput } from "./fileInput";
import styles from "./styles.scss";

function DocumentUpload({ folder, namespace, type, close }: Props) {
  const { isRequestPending, uploadDocument } = useUploadDocument(folder);
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.documentUpload}
      header={t("documentUpload.title")}
      close={close}
    >
      <div className={styles.main}>
        {isRequestPending ? (
          <div className={styles.loader}>
            <div>
              <Loader />
            </div>
          </div>
        ) : (
          <DropZone
            className={styles.dropZone}
            drop={(file) =>
              uploadDocument({
                namespace,
                type,
                folder,
                file,
              })
            }
          >
            <Icon className={styles.icon} />
            <h2 className={styles.message}>{t("documentUpload.message")}</h2>
            <FileInput
              placeholder={t("documentUpload.placeholder")}
              input={(file) =>
                uploadDocument({
                  namespace,
                  type,
                  folder,
                  file,
                })
              }
            />
          </DropZone>
        )}
      </div>
    </Modal>
  );
}

export { DocumentUpload };
